import { useState, useEffect } from "react";
import "../../SalesMasterPages/ViewLeadDetail/ViewLeadDetail.css";
import React from "react";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import axios from "axios";
import Wrapper from "../../../components/UI/Wrapper";
import { useLocation } from "react-router-dom";
import GetDate23 from "../../../JsCodes/GetDate";
import { useNavigate } from "react-router-dom";
import images1 from "../../../images/Carrymypet-01.png";
import images2 from "../../../images/Group 446.jpg";
import mailIcon from "../../../Icons/mail.png";
import CryptoJS from "crypto-js";
import quoation from "../../../images/Quation.png";
import pencil from "../../../images/pencil.jpg";
import edit from "../../../images/edit.png";
import rectangle from "../../../images/Rectangle.png";
import add from "../../../images/Add_button.jpg";
import updatebutton from "../../../images/update_button.jpg";

const InternationalRelocation = () => {
  const location = useLocation();
  const baseAPI = process.env.REACT_APP_API_URL;
  const [decryptionError, setDecryptionError] = useState(false);
  const navigate = useNavigate();
  const [isEditMode, setIsEditMode] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const relocation_id = location.state?.relocation_id;
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

  const crateData = [
    { chargeable_wt: 0, actual_crate_size: 0 },
    { chargeable_wt: 147, actual_crate_size: 1 },
    { chargeable_wt: 89, actual_crate_size: 2 },
    { chargeable_wt: 66, actual_crate_size: 3 },
    { chargeable_wt: 48, actual_crate_size: 4 },
    { chargeable_wt: 35, actual_crate_size: 5 },
    { chargeable_wt: 17, actual_crate_size: 6 },
  ];

  const Relocation_ID = decryptRelocationID(relocation_id);
  const [inputs, setInputs] = useState([
    {
      cmp_additional_sow_id: "",
      Relocation_ID,
      specific_requirement: "",
      price: "",
    },
  ]);

  const handleAddFields = () => {
    setInputs([
      ...inputs,
      { Relocation_ID, specific_requirement: "", price: "" },
    ]);
  };

  const handleChange1 = (index, event) => {
    const values = [...inputs];
    values[index][event.target.name] = event.target.value;
    setInputs(values);
  };

  const handleCheckboxChange = (e) => {
    setIsCheckboxChecked(e.target.checked);
  };

  const [domesticSOW, setDomesticSOW] = useState({
    relocation_id: Relocation_ID,
    fit_to_fly_requirement: "",
    remark: "",
    crate_require_type: "",
    crate_size: "",
    discount: "",
    pet_boarding: "",
    vehicle_type: "",
    microchip: "",
    titre_test: "",
    buying: "",
    chargeable_wt: "",
    pet_carriers: "",
  });

  const [firstItem, setFirstItem] = useState({
    relocationdetail_id: "",
    service_type: "",
    origin_city: "",
    destination_city: "",
    mode_of_transport: "",
    relocation_id: "",
    relocation_detail: "",
    origin_city1: "",
    destination_city1: "",
    delivery_type: "",
    delivery_type_name: "",
    ServiceTypeName: "",
    petbreedtype: "",
    pettype: "",
    number_of_pets: "",
    job_type: "",
    name: "",
  });

  function QuotationBuilderPage(relocation_id) {
    navigate("/QuotationBuilder", { state: { relocation_id: relocation_id } });
  }

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
  };

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);
      setDecryptionError(true);

      return null;
    }
  }

  const goToLeadList = () => {
    // Redirect to another page
    navigate("/LeadList");
  };

  const handleChange2 = (e) => {
    const { name, value } = e.target;
    setDomesticSOW((prevItem) => ({
      ...prevItem,
      relocation_id: Relocation_ID,
      [name]: name === "fit_to_fly_requirement" ? value === "true" : value,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const selectedCrate = crateData.find(
      (crate) => crate.actual_crate_size === parseInt(value)
    );

    const chargeableWt = selectedCrate ? selectedCrate.chargeable_wt : "";

    setDomesticSOW((prevItem) => ({
      ...prevItem,
      relocation_id: Relocation_ID,
      [name]: value,
      chargeable_wt: chargeableWt,
    }));
  };

  const handleChange3 = (e) => {
    const { name, value } = e.target;
    setDomesticSOW((prevItem) => ({
      ...prevItem,
      relocation_id: Relocation_ID,
      [name]: name === "microchip" ? value === "true" : value,
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (!isCheckboxChecked) {
      alert("Please confirm the declaration before proceeding.");
      return;
    }

    const storedToken = JSON.parse(localStorage.getItem("token"));

    try {
      const response1 = await axios.post(
        `${baseAPI}userpost/AddUpdateInternationalSOW`,
        domesticSOW,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      const response = await axios.post(
        `${baseAPI}userpost/AddUpdateAdditionalSOW`,
        inputs,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      setIsEditMode(!isEditMode);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };









  
  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetSOWRelocationDetail?relocation_id=` +
            Relocation_ID,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setFirstItem(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });

      axios
        .get(
          `${baseAPI}userget/GetSOWInternational?relocation_id=` +
            Relocation_ID,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response1) => {
          setDomesticSOW(response1.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });

      axios
        .get(
          `${baseAPI}userget/GetAdditionalSOW?relocation_id=` + Relocation_ID,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setInputs(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching additional SOW detail:", error);
        });
    }
  }, []);


     const [records, setRecords] = useState([
      { from: "", to: "", vehicleType: "", description: "" },
    ]);
  
    const handleInputChange = (index, field, value) => {
      const updatedRecords = [...records];
      updatedRecords[index][field] = value;
      setRecords(updatedRecords);
    };
  
    const addRecord = () => {
      setRecords([...records, { from: "", to: "", vehicleType: "", description: "" }]);
    };
  
    const removeRecord = (index) => {
      const updatedRecords = records.filter((_, i) => i !== index);
      setRecords(updatedRecords);
    };
  
    const saveData = async () => {
      try {
        const response = await fetch("/api/save-transportation-charges", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(records),
        });
  
        if (response.ok) {
          alert("Data saved successfully!");
        } else {
          alert("Error saving data.");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };








  return (
    <div>
      <div className="app-container-viewLeadDetails">
        <MiniDrawer />
        <div className="container-fluid container-viewLeadDetails">
          <div className="country-header">
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                <a style={{ cursor: "pointer" }} onClick={goToLeadList}>
                  Scope of Work{" "}
                </a>{" "}
                | <HomeOutlinedIcon />{" "}
                <span style={{ fontSize: "20px" }}>&gt; Lead Details</span>
                <span style={{ fontSize: "20px" }}>&gt; View Lead Details</span>
                <span style={{ fontSize: "20px" }}>&gt; Scope of Work</span>
              </h1>
            </div>
            <div>
              <span
                style={{
                  background: "#A3519F",
                  color: "white",
                  padding: "8px",
                }}
              >
                LeadID: {firstItem.relocation_id}
              </span>
            </div>
          </div>
          <Wrapper className="LeadDetails2">
            {/* ----------------------------------Step1 & Step 2-------------------------------- */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "2px",
                backgroundColor: "white",
                paddingBottom: "5px",
                borderRadius: "10px 10px 10px 10px",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    paddingTop: "1rem",
                    paddingLeft: "1rem",
                  }}
                >
                  Step 1 | Step 2
                </span>
                <div style={{ borderBottom: "2px solid blue," }}></div>
              </div>
              {/* ----------------------------------Quotation builder-------------------------------- */}
              <div>
                <button
                  onClick={() => QuotationBuilderPage(firstItem.relocation_id)}
                  className="btn btn-primary"
                  style={{
                    margin: "5px 4px 5px 0px",
                    backgroundColor: "white",
                    color: "#6A6A6A",
                    borderColor: "#C0C6CC",
                    height: "53px",
                    width: "210px",
                  }}
                >
                  <img
                    src={quoation}
                    alt="Quotation Builder"
                    style={{
                      marginRight: "8px",
                      width: "10px",
                      height: "13px",
                      marginBottom: "3px",
                    }}
                  />
                  QUOTATION BUILDER
                </button>

                <button
                  className={
                    isEditMode
                      ? "btn btn-primary edit-Button-on"
                      : "btn btn-primary edit-Button-off"
                  }
                  onClick={toggleEditMode}
                  style={{
                    margin: "5px 4px 5px 0px",
                    backgroundColor: "white",
                    color: "#6A6A6A",
                    borderColor: "#C0C6CC",
                    height: "55px",
                    width: "84px",
                  }}
                >
                  <img
                    src={pencil}
                    alt="Quotation Builder"
                    style={{
                      marginRight: "8px",
                      width: "12px",
                      height: "13px",
                      marginBottom: "3px",
                    }}
                  />
                  EDIT
                </button>

                <button
                  className="btn btn-primary"
                  style={{
                    margin: "5px 4px 5px 0px", //
                    backgroundColor: "white",
                    color: "#6A6A6A",
                    borderColor: "#C0C6CC",
                    height: "55px",
                    width: "128px", //
                  }}
                >
                  <img
                    src={edit}
                    alt="Lead-List"
                    style={{
                      marginRight: "8px",
                      width: "18px",
                      height: "18px",
                      marginBottom: "3px",
                    }}
                  />
                  LEAD LIST
                </button>
              </div>
            </div>
          </Wrapper>
          <br />
          {/* ------------------------lead deatil--------------------- */}

          <Wrapper className="LeadDetails">
            {successMessage && (
              <div style={{ color: "green" }}>{successMessage}</div>
            )}

            <div className="viewLeadDetails-form">
              <table
                style={{
                  width: "100%",
                  color: "#6A6A6A",

                  borderRadius: "12px",
                }}
              >
                <tr className="viewLeadDetailsHeading">
                  <th
                    colSpan={4}
                    style={{
                      background: "#5B489D",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    <span style={{ fontSize: "18px" }}> Details </span>
                  </th>
                </tr>
                {/* <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Relocation ID</span>
                  </th>
                  <td>
                    <span>{firstItem.relocation_id}</span>
                  </td>
                  <th>
                    <span>Name</span>
                  </th>
                  <td>
                    <span>{firstItem.name}</span>
                  </td>
                </tr> */}

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Service Type</span>
                  </th>
                  <td>
                    <span>{firstItem.ServiceTypeName}</span>
                  </td>
                  <th>
                    <span>Delivery Type</span>
                  </th>
                  <td>
                    <span>{firstItem.delivery_type_name}</span>
                  </td>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Customer Name</span>
                  </th>
                  <td>
                    <span>{firstItem.name}</span>
                  </td>
                  <th>
                    <span>Number Of Pets</span>
                  </th>
                  <td>
                    <span>{firstItem.number_of_pets}</span>
                  </td>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Pet Name</span>
                  </th>
                  <td>
                    <span>Simbha</span>
                  </td>
                  <th>
                    <span>Pet Type & Breed</span>
                  </th>
                  <td>
                    <span>
                      {firstItem.pettype} & {firstItem.petbreedtype}
                    </span>
                  </td>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Origin</span>
                  </th>
                  <td>
                    <span>{firstItem.origin_city1}</span>
                  </td>
                  <th>
                    <span>Destination</span>
                  </th>
                  <td>
                    <span>{firstItem.destination_city1}</span>
                  </td>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Mode Of Transport</span>
                  </th>
                  <td>
                    <span>{firstItem.mode_of_transport}</span>
                  </td>
                  <th>
                    <span>Airline Name</span>
                  </th>
                  <td>
                    <span>Spicejet</span>
                  </td>
                </tr>
              </table>
            </div>
            {isEditMode ? (
              <>
                {/* ----------Edit mode--------------- */}

                <table
                  style={{
                    background: "rgb(248, 249, 250)",
                    width: "100%",
                    borderRadius: "12px",
                  }}
                >
                  <tr style={{ paddingTop: "0.5rem" }}>
                    <th>
                      <span
                        style={{
                          fontSize: "18px",
                          wordSpacing: "0.1rem",
                          color: "#6A6A6A",
                          paddingTop: "0.5rem",
                          paddingLeft: "5px",
                        }}
                      >
                        {" "}
                        1. Do you Reqiure fit-to-fly Certificate ?{" "}
                      </span>
                    </th>
                  </tr>

                  <tr className="viewLeadDetailsHeadingradio">
                    <td
                      style={{
                        paddingRight: "0.5rem",
                        color: "#A0A0A0",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <span style={{ paddingTop: "5px", paddingLeft: "28px" }}>
                        {" "}
                        A fit-to-fly Certificate(NOC) is required from a
                        certified Vet 24 hours before your flight. Cary My Pet
                        Assists you in gathering an NOC{" "}
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td
                      style={{
                        paddingTop: "5px",
                        paddingTop: "0.5rem",
                        paddingLeft: "5px",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value="true"
                        checked={domesticSOW.fit_to_fly_requirement === true}
                        onChange={handleChange2}
                      />
                      <label
                        style={{
                          paddingLeft: "1rem",
                          color: "#6A6A6A",
                          fontWeight: "600",
                        }}
                      >
                        {" "}
                        Fit-to-fly Certificate(Assisted)
                      </label>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeadingradio">
                    <td style={{ paddingTop: "0.5rem" }}>
                      <label style={{ paddingLeft: "2rem", color: "#A0A0A0" }}>
                        {" "}
                        We are Partnered with certified internation labs at
                        pocket-friendly rates
                      </label>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeadingradio">
                    <td
                      style={{
                        paddingTop: "5px",
                        paddingTop: "0.5rem",
                        paddingLeft: "5px",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value="false"
                        checked={domesticSOW.fit_to_fly_requirement === false}
                        onChange={handleChange2}
                      />
                      <label
                        style={{
                          paddingLeft: "1rem",
                          color: "#6A6A6A",
                          fontWeight: "600",
                        }}
                      >
                        {" "}
                        No Thanks, I will get one myself
                      </label>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeadingradio">
                    <td style={{ paddingTop: "5px", paddingTop: "0.5rem" }}>
                      <label
                        style={{
                          paddingLeft: "2rem",
                          color: "#A0A0A0",
                          paddingLeft: "28px",
                        }}
                      >
                        {" "}
                        A fit-to-fly Certificate(NOC) is mandatory for a pet's
                        international travel.
                      </label>
                    </td>
                  </tr>
                </table>

                {/* <table
                  style={{
                    background: "rgb(248, 249, 250)",
                    width: "100%",
                    borderRadius: "12px",
                    marginTop: "1rem",
                  }}
                >
                  <tr style={{ paddingTop: "0.5rem" }}>
                    <th>
                      <span
                        style={{
                          fontSize: "18px",
                          wordSpacing: "0.1rem",
                          color: "#6A6A6A",
                          paddingTop: "0.5rem",
                          paddingLeft: "5px",
                        }}
                      >
                        {" "}
                        2. Do you Reqiure Microchip?{" "}
                      </span>
                    </th>
                  </tr>

                  <tr className="viewLeadDetailsHeadingradio">
                    <td
                      style={{
                        paddingRight: "0.5rem",
                        color: "#A0A0A0",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <span style={{ paddingTop: "5px", paddingLeft: "28px" }}>
                        Microchip is mandatory for International Relocation.
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td
                      style={{
                        paddingTop: "5px",
                        paddingTop: "0.5rem",
                        paddingLeft: "5px",
                      }}
                    >
                      <input
                        type="radio"
                        name="microchip"
                        value="true"
                        checked={
                          domesticSOW.microchip === true
                        }
                        onChange={handleChange3}
                      />
                      <label
                        style={{
                          paddingLeft: "1rem",
                          color: "#6A6A6A",
                          fontWeight: "600",
                        }}
                      >
                        {" "}
                        Microchip(Assisted)
                      </label>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeadingradio">
                    <td style={{ paddingTop: "0.5rem" }}>
                      <label style={{ paddingLeft: "2rem", color: "#A0A0A0" }}>


                      </label>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeadingradio">
                    <td
                      style={{
                        paddingTop: "5px",
                        paddingTop: "0.5rem",
                        paddingLeft: "5px",
                      }}
                    >
                      <input
                        type="radio"
                        name="microchip"
                        value="false"
                        checked={
                          domesticSOW.microchip === false
                        }
                        onChange={handleChange3}
                      />
                      <label
                        style={{
                          paddingLeft: "1rem",
                          color: "#6A6A6A",
                          fontWeight: "600",
                        }}
                      >
                        {" "}
                        No Thanks, I will get one myself
                      </label>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeadingradio">
                    <td style={{ paddingTop: "5px", paddingTop: "0.5rem" }}>
                      <label
                        style={{
                          paddingLeft: "2rem",
                          color: "#A0A0A0",
                          paddingLeft: "28px",
                        }}
                      >
                        {" "}
                        Microchip is mandatory for a pet's
                        international travel.
                      </label>
                    </td>
                  </tr>
                </table> */}

                <div
                  style={{
                    background: "rgb(248, 249, 250)",
                    width: "100%",
                    borderRadius: "12px",
                    marginTop: "1rem",
                    padding: "1rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ flex: "1" }}>
                    <span
                      style={{
                        fontSize: "18px",
                        wordSpacing: "0.1rem",
                        color: "#6A6A6A",
                        paddingTop: "0.5rem",
                        paddingLeft: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      2. Do you Require Microchip?
                    </span>
                  </div>
                  <div style={{ flex: "2", display: "flex", gap: "1rem" }}>
                    <div>
                      <input
                        type="radio"
                        name="microchip"
                        value="true"
                        checked={domesticSOW.microchip === true}
                        onChange={handleChange3}
                      />
                      <label
                        style={{
                          paddingLeft: "0.5rem",
                          color: "#6A6A6A",
                          fontWeight: "600",
                        }}
                      >
                        Microchip (Assisted)
                      </label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        name="microchip"
                        value="false"
                        checked={domesticSOW.microchip === false}
                        onChange={handleChange3}
                      />
                      <label
                        style={{
                          paddingLeft: "0.5rem",
                          color: "#6A6A6A",
                          fontWeight: "600",
                        }}
                      >
                        No Thanks, I will get one myself
                      </label>
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    background: "rgb(248, 249, 250)",
                    width: "100%",
                    borderRadius: "12px",
                    marginTop: "1rem",
                    padding: "1rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ flex: "1" }}>
                    <span
                      style={{
                        fontSize: "18px",
                        wordSpacing: "0.1rem",
                        color: "#6A6A6A",
                        paddingTop: "0.5rem",
                        paddingLeft: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      3. Titre Test
                    </span>
                  </div>
                  <div style={{ flex: "2", display: "flex", gap: "1rem" }}>
                    <select
                      className="form-control"
                      style={{ width: "45%", color: "#6A6A6A" }}
                      onChange={handleChange2}
                      name="titre_test"
                      value={domesticSOW.titre_test}
                    >
                      <option value="0">Choose Titer Test</option>
                      <option value="1">Already Done</option>
                      <option value="2">Titer test (Indian Lab)</option>
                      <option value="3">Titer test (European Lab)</option>
                    </select>
                  </div>
                </div>

                <table
                  style={{
                    background: "rgb(248, 249, 250)",
                    width: "100%",
                    marginTop: "1rem",
                    borderRadius: "12px",
                  }}
                >
                  <tr className="viewLeadDetailsHeadingradio">
                    <th colSpan={3} style={{ paddingTop: "0.5rem" }}>
                      <span
                        style={{
                          fontSize: "18px",
                          wordSpacing: "0.1rem",
                          color: "#6A6A6A",
                          paddingTop: "0.5rem",
                          paddingLeft: "5px",
                        }}
                      >
                        {" "}
                        4. Do you have a Pet Crate ?{" "}
                      </span>
                    </th>
                  </tr>

                  <tr className="viewLeadDetailsHeadingradio">
                    <td
                      colSpan={3}
                      style={{ paddingRight: "1rem", color: "#A0A0A0" }}
                    >
                      {"   "}

                      <label
                        style={{ paddingTop: "0.5rem", paddingLeft: "28px" }}
                      >
                        A Pet Crate is Mandatory for international Pet Travel by
                        a flight.
                      </label>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeadingradio">
                    <td style={{ width: "20%", paddingTop: "0.5rem" }}>
                      <input
                        type="radio"
                        name="crate_require_type"
                        value="1"
                        checked={domesticSOW.crate_require_type === "1"}
                        onChange={handleChange2}
                      />
                      <span
                        style={{
                          marginLeft: "0.5rem",
                          fontWeight: "400",
                          color: "6A6A6A",
                        }}
                      >
                        Complementary
                      </span>
                    </td>
                    <td
                      style={{
                        width: "20%",
                        paddingTop: "0.5rem",
                        marginLeft: "0.5rem",
                      }}
                    >
                      <input
                        type="radio"
                        name="crate_require_type"
                        value="2"
                        checked={domesticSOW.crate_require_type === "2"}
                        onChange={handleChange2}
                      />{" "}
                      <span
                        style={{
                          marginLeft: "0.5rem",
                          fontWeight: "400",
                          color: "6A6A6A",
                        }}
                      >
                        Rent
                      </span>
                    </td>
                    <td style={{ width: "20%", paddingTop: "0.5rem" }}>
                      <input
                        type="radio"
                        name="crate_require_type"
                        value="3"
                        checked={domesticSOW.crate_require_type === "3"}
                        onChange={handleChange2}
                      />{" "}
                      <span
                        style={{
                          marginLeft: "0.5rem",
                          fontWeight: "400",
                          color: "6A6A6A",
                        }}
                      >
                        Own
                      </span>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeadingradio">
                    <th
                      colSpan={3}
                      style={{
                        fontWeight: "600",
                        color: "#6A6A6A",
                        width: "100%",
                        paddingTop: "0.5rem",
                      }}
                    >
                      Based on your pet's dimensions, your recommended crate
                      size is: 32 inches
                    </th>
                  </tr>
                  <tr className="viewLeadDetailsHeadingradio">
                    <td style={{ paddingTop: "0.5rem" }}>
                      <select
                        className="form-control"
                        style={{ width: "45%", color: "#6A6A6A" }}
                        onChange={handleChange}
                        name="crate_size"
                        value={domesticSOW.crate_size}
                      >
                        <option value="0">Choose Crate</option>
                        <option value="1">48 Inches</option>
                        <option value="2">40 inches</option>
                        <option value="3">36 inches</option>
                        <option value="4">32 inches</option>
                        <option value="5">28 inches</option>
                        <option value="6">24 inches</option>
                        <option value="7">CR 82</option>
                      </select>
                    </td>
                    <td>
                      Chargeable Weight:{" "}
                      <span>{domesticSOW.chargeable_wt}</span>
                    </td>
                    <td>
                      <span
                        style={{
                          fontSize: "18px",
                          wordSpacing: "0.1rem",
                          color: "#6A6A6A",
                          paddingTop: "0.5rem",
                          paddingLeft: "5px",
                          fontWeight: "bold",
                        }}
                      >
                        {" "}
                        Buying:
                      </span>
                      <input
                        className="form-control"
                        type="text"
                        name="buying"
                        value={domesticSOW.buying}
                        placeholder="Please Enter*"
                        onChange={handleChange2}
                      />
                    </td>
                  </tr>
                </table>
                <div
                  style={{
                    background: "rgb(248, 249, 250)",
                    width: "100%",
                    borderRadius: "12px",
                    marginTop: "1rem",
                    padding: "1rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ flex: "1" }}>
                    <span
                      style={{
                        fontSize: "18px",
                        wordSpacing: "0.1rem",
                        color: "#6A6A6A",
                        paddingTop: "0.5rem",
                        paddingLeft: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      5. Pet Carriers
                    </span>
                  </div>
                  <div style={{ flex: "2", display: "flex", gap: "1rem" }}>
                    <div>
                      <input
                        type="radio"
                        name="pet_carriers"
                        value="1"
                        checked={domesticSOW.pet_carriers === 1}
                        onChange={handleChange2}
                      />
                      <label
                        style={{
                          paddingLeft: "0.5rem",
                          color: "#6A6A6A",
                          fontWeight: "600",
                        }}
                      >
                        Cabin Travel
                      </label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        name="pet_carriers"
                        value="2"
                        checked={domesticSOW.pet_carriers === 2}
                        onChange={handleChange2}
                      />
                      <label
                        style={{
                          paddingLeft: "0.5rem",
                          color: "#6A6A6A",
                          fontWeight: "600",
                        }}
                      >
                        Cargo Mode
                      </label>
                    </div>
                  </div>
                </div>

                <table
                  style={{
                    background: "rgb(248, 249, 250)",
                    width: "100%",
                    borderRadius: "12px",
                  }}
                >
                  <tr className="viewLeadDetailsHeadingradio">
                    <td style={{ paddingTop: "0.5rem" }}>
                      <table style={{ width: "100%" }}>
                        <tr>
                          <td>
                            <span
                              style={{
                                fontSize: "18px",
                                wordSpacing: "0.1rem",
                                color: "#6A6A6A",
                                paddingTop: "0.5rem",
                                paddingLeft: "5px",
                                fontWeight: "bold",
                              }}
                            >
                              {" "}
                              Choose Vehicle type:
                            </span>
                            <select
                              className="form-control"
                              name="vehicle_type"
                              value={domesticSOW.vehicle_type}
                              onChange={handleChange2}
                            >
                              <option value="0">Not required</option>
                              <option value="1">4 seater</option>
                              <option value="2">7 seater</option>
                            </select>
                          </td>
                          <td>
                            <span
                              style={{
                                fontSize: "18px",
                                wordSpacing: "0.1rem",
                                color: "#6A6A6A",
                                paddingTop: "0.5rem",
                                paddingLeft: "5px",
                                fontWeight: "bold",
                              }}
                            >
                              {" "}
                              Pet Boarding:
                            </span>
                            <select
                              className="form-control"
                              name="pet_boarding"
                              value={domesticSOW.pet_boarding}
                              onChange={handleChange2}
                            >
                              <option value="0">Not required</option>
                              <option value="1">1 day</option>
                              <option value="2">2 day</option>
                              <option value="3">3 day</option>
                              <option value="4">4 day</option>
                              <option value="5">5 day</option>
                            </select>
                          </td>
                          <td>
                            <span
                              style={{
                                fontSize: "18px",
                                wordSpacing: "0.1rem",
                                color: "#6A6A6A",
                                paddingTop: "0.5rem",
                                paddingLeft: "5px",
                                fontWeight: "bold",
                              }}
                            >
                              {" "}
                              Discount (if Any):
                            </span>
                            <input
                              className="form-control"
                              type="text"
                              name="discount"
                              value={domesticSOW.discount}
                              placeholder="Please Enter*"
                              onChange={handleChange2}
                            />
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <th
                      style={{
                        fontSize: "18px",
                        color: "#6A6A6A",
                        paddingTop: "1rem",
                        paddingLeft: "0.5rem",
                        paddingBottom: "0.2rem",
                      }}
                    >
                      Any Remark
                    </th>
                  </tr>
                  <tr>
                    <td
                      colSpan={3}
                      style={{ paddingLeft: "0.5rem", paddingBottom: "1rem" }}
                    >
                      <input
                        style={{
                          borderRadius: "1px solid #6A6A6A",
                          width: "98%",
                        }}
                        type="input"
                        name="remark"
                        value={domesticSOW.remark}
                        onChange={handleChange2}
                      />
                    </td>
                  </tr>
                </table>
                <div>
                  {inputs.map((input, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        background: "rgb(248, 249, 250)",
                        paddingLeft: "0.5rem",
                        marginTop: "15px",
                        marginBottom: "10px",
                        height: "160px",
                      }}
                    >
                      <span
                        style={{
                          marginBottom: "0.5rem",
                          fontSize: "18px",
                          color: "#6A6A6A",
                          fontWeight: "700",
                        }}
                      >
                        Any Pet-Specific or Service Requirements We Should Know
                        About?
                      </span>
                      <input
                        name="specific_requirement"
                        style={{
                          marginBottom: "1rem",
                          width: "98%",
                          height: "4rem",
                        }}
                        value={input.specific_requirement}
                        onChange={(event) => handleChange1(index, event)}
                      />
                      <span
                        style={{
                          marginBottom: "0.5rem",
                          fontSize: "18px",
                          color: "#6A6A6A",
                          fontWeight: "700",
                        }}
                      >
                        Price
                      </span>
                      <input
                        name="price"
                        style={{
                          marginBottom: "1rem",
                          width: "15%",
                          height: "4rem",
                        }}
                        value={input.price}
                        onChange={(event) => handleChange1(index, event)}
                      />
                    </div>
                  ))}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <button
                      onClick={handleAddFields}
                      style={{
                        position: "relative",
                        padding: "0px",
                        backgroundColor: "transparent",
                        border: "none",
                      }}
                    >
                      <img
                        src={rectangle}
                        alt="Add"
                        style={{ width: "100%", height: "auto" }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                      >
                        <img
                          src={add}
                          alt="Overlay"
                          style={{ width: "80%", height: "auto" }}
                        />
                      </div>
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* ----------view mode--------------- */}

                <table
                  style={{
                    background: "rgb(248, 249, 250)",
                    width: "100%",
                    borderRadius: "12px",
                    marginBottom: "12px",
                  }}
                >
                  <tr>
                    <th
                      colSpan="2"
                      style={{ textAlign: "left", padding: "1rem 0.5rem" }}
                    >
                      <span
                        style={{
                          fontSize: "18px",
                          wordSpacing: "0.1rem",
                          color: "#6A6A6A",
                        }}
                      >
                        1. Please Select your Baggage type?
                      </span>
                    </th>
                  </tr>
                  <tr style={{ display: "flex" }}>
                    <td
                      style={{
                        padding: "0.5rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        color: "#6A6A6A",
                        fontWeight: "600",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value="true"
                        checked={domesticSOW.fit_to_fly_requirement === true}
                        disabled
                      />
                      <label>Accompanied Baggage</label>
                    </td>
                    <td
                      style={{
                        padding: "0.5rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        color: "#6A6A6A",
                        fontWeight: "600",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value="false"
                        checked={domesticSOW.fit_to_fly_requirement === false}
                        disabled
                      />
                      <label>Unaccompanied Baggage</label>
                    </td>
                  </tr>
                  <div style={{ padding: "0 0 10px 0" }}>
                    {" "}
                    <span style={{ padding: "0 0 0 27px" }}>
                      Accompanied Baggage means you travel with your pet, either
                      in-cabin or in-cargo. Unaccompanied Baggage allows your
                      pet to travel without you.{" "}
                    </span>
                  </div>
                </table>

                <table
                  style={{
                    background: "rgb(248, 249, 250)",
                    width: "100%",
                    borderRadius: "12px",
                    marginBottom: "12px",
                  }}
                >
                  <tr>
                    <th
                      colSpan="2"
                      style={{ textAlign: "left", padding: "1rem 0.5rem" }}
                    >
                      <span
                        style={{
                          fontSize: "18px",
                          wordSpacing: "0.1rem",
                          color: "#6A6A6A",
                        }}
                      >
                        2. You need to Microchip your Pet
                      </span>
                    </th>
                  </tr>
                  <tr style={{ display: "flex" }}>
                    <td
                      style={{
                        padding: "0.5rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        color: "#6A6A6A",
                        fontWeight: "600",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value="true"
                        checked={domesticSOW.fit_to_fly_requirement === true}
                        disabled
                      />
                      <label>Microchip (Required)</label>
                    </td>
                    <td
                      style={{
                        padding: "0.5rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        color: "#6A6A6A",
                        fontWeight: "600",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value="false"
                        checked={domesticSOW.fit_to_fly_requirement === false}
                        disabled
                      />
                      <label>Already Microchipped.</label>
                    </td>
                  </tr>
                  <div style={{ padding: "0 0 10px 0" }}>
                    {" "}
                    <span style={{ padding: "0 0 0 27px" }}>
                      A microchip is a permanent proof of identification.
                      Standard pet microchips are of the ISO 11784/11785
                      variety.{" "}
                    </span>
                  </div>
                </table>

                <table
                  style={{
                    background: "rgb(248, 249, 250)",
                    width: "100%",
                    borderRadius: "12px",
                    marginBottom: "12px",
                  }}
                >
                  <tr>
                    <th
                      colSpan="2"
                      style={{ textAlign: "left", padding: "1rem 0.5rem" }}
                    >
                      <span
                        style={{
                          fontSize: "18px",
                          wordSpacing: "0.1rem",
                          color: "#6A6A6A",
                        }}
                      >
                        3. You need to Titer test your pet{" "}
                        <span>
                          ( for pet travel to EU, UK, Japan, Australia, New
                          Zealand, Hongkong, Singapore, and all rabies free
                          destination country )
                        </span>
                      </span>
                    </th>
                  </tr>
                  <tr style={{ display: "flex" }}>
                    <td
                      style={{
                        padding: "0.5rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        color: "#6A6A6A",
                        fontWeight: "600",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value="true"
                        checked={domesticSOW.fit_to_fly_requirement === true}
                        disabled
                      />
                      <label>Titer Test (Required)</label>
                    </td>
                    <td
                      style={{
                        padding: "0.5rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        color: "#6A6A6A",
                        fontWeight: "600",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value="false"
                        checked={domesticSOW.fit_to_fly_requirement === false}
                        disabled
                      />
                      <label>Already Titer Tested</label>
                    </td>
                    <td
                      style={{
                        padding: "0.5rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        color: "#6A6A6A",
                        fontWeight: "600",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value="false"
                        checked={domesticSOW.fit_to_fly_requirement === false}
                        disabled
                      />
                      <label>Not Applicable</label>
                    </td>
                  </tr>
                  <div style={{ padding: "0px 19px 11px 28px" }}>
                    {" "}
                    <span>
                      A rabies titer test confirms the success of a rabies
                      vaccine & checks the number of antibodies in your pet’s
                      blood. The pet will receive a Rabies booster shot after
                      the microchipping process. Pet must wait for 30 days after
                      booster has been given. After 30 days, the blood sample is
                      collected & sent to a lab for testing. The lab will return
                      test results after 4 weeks. Results are then shared with
                      pet parents, and the journey is planned according to the
                      county’s import requirements.
                    </span>
                  </div>
                  <div style={{ flex: "2", display: "flex", gap: "1rem" }}>
                    <select
                      className="form-control"
                      style={{ width: "23%", color: "#6A6A6A" }}
                      disabled
                      name="titre_test"
                      value={domesticSOW.titre_test}
                    >
                      <option value="0">Choose Titer Test</option>
                      <option value="1">Already Done</option>
                      <option value="2">Titer test (Indian Lab)</option>
                      <option value="3">Titer test (European Lab)</option>
                    </select>
                  </div>
                </table>

                <table
                  style={{
                    background: "rgb(248, 249, 250)",
                    width: "100%",
                    borderRadius: "12px",
                    marginBottom: "12px",
                  }}
                >
                  <tr>
                    <th
                      colSpan="2"
                      style={{ textAlign: "left", padding: "1rem 0.5rem" }}
                    >
                      <span
                        style={{
                          fontSize: "18px",
                          wordSpacing: "0.1rem",
                          color: "#6A6A6A",
                        }}
                      >
                        4. You Need a Fit-to-Fly Certificate
                      </span>
                    </th>
                  </tr>
                  <tr style={{ display: "flex" }}>
                    <td
                      style={{
                        padding: "0.5rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        color: "#6A6A6A",
                        fontWeight: "600",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value="true"
                        checked={domesticSOW.fit_to_fly_requirement === true}
                        disabled
                      />
                      <label>Fit-to-Fly Certificate </label>
                    </td>
                    <td
                      style={{
                        padding: "0.5rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        color: "#6A6A6A",
                        fontWeight: "600",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value="false"
                        checked={domesticSOW.fit_to_fly_requirement === false}
                        disabled
                      />
                      <label>
                        No, customer will get it done on their own.{" "}
                      </label>
                    </td>
                    <td
                      style={{
                        padding: "0.5rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        color: "#6A6A6A",
                        fontWeight: "600",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value="false"
                        checked={domesticSOW.fit_to_fly_requirement === false}
                        disabled
                      />
                      <label>Complementary</label>
                    </td>
                  </tr>
                  <div style={{ padding: "0px 19px 11px 28px" }}>
                    {" "}
                    <span>
                      A Fit-to-Fly Certificate is required from a certified Vet.
                      Certificate is valid for 10 days.{" "}
                    </span>
                  </div>
                </table>

                <table
                  style={{
                    background: "rgb(248, 249, 250)",
                    width: "100%",
                    borderRadius: "12px",
                    marginBottom: "12px",
                  }}
                >
                  <tr>
                    <th
                      colSpan="2"
                      style={{ textAlign: "left", padding: "1rem 0.5rem" }}
                    >
                      <span
                        style={{
                          fontSize: "18px",
                          wordSpacing: "0.1rem",
                          color: "#6A6A6A",
                        }}
                      >
                        5. You need a De-worming Certificate
                      </span>
                    </th>
                  </tr>
                  <tr style={{ display: "flex" }}>
                    <td
                      style={{
                        padding: "0.5rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        color: "#6A6A6A",
                        fontWeight: "600",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value="true"
                        checked={domesticSOW.fit_to_fly_requirement === true}
                        disabled
                      />
                      <label>De-worming Certificate</label>
                    </td>
                    <td
                      style={{
                        padding: "0.5rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        color: "#6A6A6A",
                        fontWeight: "600",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value="false"
                        checked={domesticSOW.fit_to_fly_requirement === false}
                        disabled
                      />
                      <label>
                        No, customer will get it done on their own.{" "}
                      </label>
                    </td>
                    <td
                      style={{
                        padding: "0.5rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        color: "#6A6A6A",
                        fontWeight: "600",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value="false"
                        checked={domesticSOW.fit_to_fly_requirement === false}
                        disabled
                      />
                      <label>Complementary </label>
                    </td>
                  </tr>
                  <div style={{ padding: "0px 19px 11px 28px" }}>
                    {" "}
                    <span>
                      A de-worming certificate is issued by a certified vet once
                      the de-worming treatment is complete.{" "}
                    </span>
                  </div>
                </table>

                <table
                  style={{
                    background: "rgb(248, 249, 250)",
                    width: "100%",
                    borderRadius: "12px",
                    marginBottom: "12px",
                  }}
                >
                  {/* Question Header */}
                  <tr>
                    <th
                      colSpan="3"
                      style={{ textAlign: "left", padding: "1rem 0.5rem" }}
                    >
                      <span
                        style={{
                          fontSize: "18px",
                          wordSpacing: "0.1rem",
                          color: "#6A6A6A",
                        }}
                      >
                        6. You need an IATA approved Pet Crate
                      </span>
                    </th>
                  </tr>

                  {/* Radio Buttons */}
                  <tr style={{ display: "flex" }}>
                    <td
                      style={{
                        padding: "0.5rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        color: "#6A6A6A",
                        fontWeight: "600",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value="true"
                        checked={domesticSOW.fit_to_fly_requirement === true}
                        disabled
                      />
                      <label>Buy</label>
                    </td>
                    <td
                      style={{
                        padding: "0.5rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        color: "#6A6A6A",
                        fontWeight: "600",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value="false"
                        checked={domesticSOW.fit_to_fly_requirement === false}
                        disabled
                      />
                      <label>Own</label>
                    </td>
                  </tr>

                  {/* Description */}
                  <tr>
                    <td colSpan="3" style={{ padding: "0px 19px 11px 28px" }}>
                      <span>
                        A pet crate is mandatory for International pet travel by
                        a flight.
                      </span>
                    </td>
                  </tr>

                  {/* Horizontal Rule */}
                  <tr>
                    <td colSpan="3">
                      <hr
                        style={{
                          position: "relative",
                          width: "92%",
                          marginLeft: "25px",
                          marginTop: "-10px",
                          padding: "0px 23px 0px 15px",
                        }}
                      />
                    </td>
                  </tr>

                  {/* Additional Information */}
                  <tr>
                    <td colSpan="3" style={{ padding: "0.5rem 1rem" }}>
                      <span>
                        Based on your pet’s dimensions, your recommended crate
                        size is: 32 (32x23x24) inches
                      </span>
                    </td>
                  </tr>

                  {/* Dropdown and Input Fields */}
                  <tr>
                    <td colSpan="3">
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr 1fr",
                          gap: "1rem",
                          padding: "1rem",
                        }}
                      >
                        <div>
                          <span
                            style={{
                              fontSize: "18px",
                              wordSpacing: "0.1rem",
                              color: "#6A6A6A",
                              fontWeight: "bold",
                            }}
                          >
                            Choose Crate
                          </span>
                          <select
                            className="form-control"
                            name="vehicle_type"
                            value={domesticSOW.vehicle_type}
                            disabled
                          >
                            <option value="0">Not required</option>
                            <option value="1">Mini</option>
                            <option value="2">XL</option>
                          </select>
                        </div>

                        <div>
                          <span
                            style={{
                              fontSize: "18px",
                              wordSpacing: "0.1rem",
                              color: "#6A6A6A",
                              fontWeight: "bold",
                            }}
                          >
                            Chargeable Weight
                          </span>
                          <select
                            className="form-control"
                            name="pet_boarding"
                            value={domesticSOW.pet_boarding}
                            disabled
                          >
                            <option value="0">Not required</option>
                            <option value="1">1 day</option>
                            <option value="2">2 day</option>
                            <option value="3">3 day</option>
                            <option value="4">4 day</option>
                            <option value="5">5 day</option>
                          </select>
                        </div>

                        <div>
                          <span
                            style={{
                              fontSize: "18px",
                              wordSpacing: "0.1rem",
                              color: "#6A6A6A",
                              fontWeight: "bold",
                            }}
                          >
                            Additional Chargeable Weight
                          </span>
                          <input
                            className="form-control"
                            type="text"
                            name="discount"
                            value={domesticSOW.discount}
                            placeholder="Please Enter*"
                            disabled
                          />
                        </div>
                        <div>
                          <span
                            style={{
                              fontSize: "18px",
                              wordSpacing: "0.1rem",
                              color: "#6A6A6A",
                              fontWeight: "bold",
                            }}
                          >
                            Due Carrier
                          </span>
                          <input
                            className="form-control"
                            type="text"
                            name="discount"
                            value={domesticSOW.discount}
                            placeholder="Please Enter*"
                            disabled
                          />
                        </div>
                        <div>
                          <span
                            style={{
                              fontSize: "18px",
                              wordSpacing: "0.1rem",
                              color: "#6A6A6A",
                              fontWeight: "bold",
                            }}
                          >
                            Buying
                          </span>
                          <input
                            className="form-control"
                            type="text"
                            name="discount"
                            value={domesticSOW.discount}
                            placeholder="Please Enter*"
                            disabled
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>

                <table
                  style={{
                    background: "rgb(248, 249, 250)",
                    width: "100%",
                    borderRadius: "12px",
                    marginBottom: "12px",
                  }}
                >
                  {/* Question Header */}
                  <tr>
                    <th
                      colSpan="3"
                      style={{ textAlign: "left", padding: "1rem 0.5rem" }}
                    >
                      <span
                        style={{
                          fontSize: "18px",
                          wordSpacing: "0.1rem",
                          color: "#6A6A6A",
                        }}
                      >
                        7. Charges for Destination based requirements
                      </span>
                    </th>
                  </tr>
                  {/* Dropdown and Input Fields */}
                  <tr>
                    <td colSpan="3">
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr 1fr",
                          gap: "1rem",
                          padding: "1rem",
                        }}
                      >
                        <div>
                          <span
                            style={{
                              fontSize: "18px",
                              wordSpacing: "0.1rem",
                              color: "#6A6A6A",
                              fontWeight: "bold",
                            }}
                          >
                            Import Permit
                          </span>
                          <select
                            className="form-control"
                            name="vehicle_type"
                            value={domesticSOW.vehicle_type}
                            disabled
                          >
                            <option value="0">Not required</option>
                            <option value="1">Mini</option>
                            <option value="2">XL</option>
                          </select>
                        </div>

                        <div>
                          <span
                            style={{
                              fontSize: "18px",
                              wordSpacing: "0.1rem",
                              color: "#6A6A6A",
                              fontWeight: "bold",
                            }}
                          >
                            Import Custom Clearance
                          </span>
                          <select
                            className="form-control"
                            name="pet_boarding"
                            value={domesticSOW.pet_boarding}
                            disabled
                          >
                            <option value="0">Not required</option>
                            <option value="1">1 day</option>
                            <option value="2">2 day</option>
                            <option value="3">3 day</option>
                            <option value="4">4 day</option>
                            <option value="5">5 day</option>
                          </select>
                        </div>

                        <div>
                          <span
                            style={{
                              fontSize: "18px",
                              wordSpacing: "0.1rem",
                              color: "#6A6A6A",
                              fontWeight: "bold",
                            }}
                          >
                            Door-to-Door Delivery
                          </span>
                          <input
                            className="form-control"
                            type="text"
                            name="discount"
                            value={domesticSOW.discount}
                            placeholder="Please Enter*"
                            disabled
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>

                <div>
                  <div className="row">
                    <div className="col-6">
                      <table
                        style={{
                          background: "rgb(248, 249, 250)",
                          width: "100%",
                          borderRadius: "12px",
                          marginBottom: "12px",
                        }}
                      >
                        {/* Question Header */}
                        <tr>
                          <th
                            colSpan="3"
                            style={{
                              textAlign: "left",
                              padding: "1rem 0.5rem",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "18px",
                                wordSpacing: "0.1rem",
                                color: "#6A6A6A",
                              }}
                            >
                              8. Pet Boarding
                            </span>
                          </th>
                        </tr>
                        {/* Dropdown and Input Fields */}
                        <tr>
                          <td colSpan="3">
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr 1fr",
                                gap: "1rem",
                                padding: "1rem",
                              }}
                            >
                              <div>
                                <span
                                  style={{
                                    fontSize: "18px",
                                    wordSpacing: "0.1rem",
                                    color: "#6A6A6A",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Pet Boarding
                                </span>
                                <select
                                  className="form-control"
                                  name="vehicle_type"
                                  value={domesticSOW.vehicle_type}
                                  disabled
                                >
                                  <option value="0">Not required</option>
                                  <option value="1">Mini</option>
                                  <option value="2">XL</option>
                                </select>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div className="col-6">
                      <table
                        style={{
                          background: "rgb(248, 249, 250)",
                          width: "100%",
                          borderRadius: "12px",
                          marginBottom: "12px",
                        }}
                      >
                        {/* Question Header */}
                        <tr>
                          <th
                            colSpan="3"
                            style={{
                              textAlign: "left",
                              padding: "1rem 0.5rem",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "18px",
                                wordSpacing: "0.1rem",
                                color: "#6A6A6A",
                              }}
                            >
                              9. Discount (If Any)
                            </span>
                          </th>
                        </tr>
                        {/* Dropdown and Input Fields */}
                        <tr>
                          <td colSpan="3">
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr 1fr",
                                gap: "1rem",
                                padding: "1rem",
                              }}
                            >
                              <div>
                                <span
                                  style={{
                                    fontSize: "18px",
                                    wordSpacing: "0.1rem",
                                    color: "#6A6A6A",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Discount
                                </span>
                                <select
                                  className="form-control"
                                  name="vehicle_type"
                                  value={domesticSOW.vehicle_type}
                                  disabled
                                >
                                  <option value="0">Not required</option>
                                  <option value="1">Mini</option>
                                  <option value="2">XL</option>
                                </select>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>

                <table
                  style={{
                    background: "rgb(248, 249, 250)",
                    width: "100%",
                    borderRadius: "12px",
                    marginBottom: "12px",
                  }}
                >
                  {/* Question Header */}
                  <tr>
                    <th
                      colSpan="3"
                      style={{ textAlign: "left", padding: "1rem 0.5rem" }}
                    >
                      <span
                        style={{
                          fontSize: "18px",
                          wordSpacing: "0.1rem",
                          color: "#6A6A6A",
                        }}
                      >
                        10. Transportation Charges
                      </span>
                    </th>
                  </tr>
                  {/* Dropdown and Input Fields */}
                  <tr>
                    <td colSpan="3">
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr 1fr",
                          gap: "1rem",
                          padding: "1rem",
                        }}
                      >
                        <div>
                          <span
                            style={{
                              fontSize: "18px",
                              wordSpacing: "0.1rem",
                              color: "#6A6A6A",
                              fontWeight: "bold",
                            }}
                          >
                            From
                          </span>
                          <input
                            className="form-control"
                            type="text"
                            name="discount"
                            value={domesticSOW.discount}
                            placeholder="Please Enter*"
                            disabled
                          />
                          {/* */}
                        </div>

                        <div>
                          <span
                            style={{
                              fontSize: "18px",
                              wordSpacing: "0.1rem",
                              color: "#6A6A6A",
                              fontWeight: "bold",
                            }}
                          >
                            To
                          </span>
                          <input
                            className="form-control"
                            type="text"
                            name="discount"
                            value={domesticSOW.discount}
                            placeholder="Please Enter*"
                            disabled
                          />
                        </div>

                        <div>
                          <span
                            style={{
                              fontSize: "18px",
                              wordSpacing: "0.1rem",
                              color: "#6A6A6A",
                              fontWeight: "bold",
                            }}
                          >
                            Vehicle Type
                          </span>
                          <select
                            className="form-control"
                            name="vehicle_type"
                            value={domesticSOW.vehicle_type}
                            disabled
                          >
                            <option value="0">Not required</option>
                            <option value="1">Mini</option>
                            <option value="2">XL</option>
                          </select>
                        </div>

                        <div>
                          <span
                            style={{
                              fontSize: "18px",
                              wordSpacing: "0.1rem",
                              color: "#6A6A6A",
                              fontWeight: "bold",
                            }}
                          >
                            Description
                          </span>
                          <select
                            className="form-control"
                            name="vehicle_type"
                            value={domesticSOW.vehicle_type}
                            disabled
                          >
                            <option value="0">Not required</option>
                            <option value="1">Mini</option>
                            <option value="2">XL</option>
                          </select>
                          {/* Horizontal Rule */}
                        </div>
                      </div>
                      <hr
                        style={{
                          position: "relative",
                          width: "96%",
                          marginLeft: "25px",
                          marginTop: "-4px",
                          padding: "0px 23px 0px 15px",
                        }}
                      />
                    </td>
                  </tr>
                </table>

                <div
                  style={{
                    background: "rgb(248, 249, 250)",
                    width: "100%",
                    borderRadius: "12px",
                    marginBottom: "12px",
                  }}
                >
                  {inputs.map((input, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        background: "rgb(248, 249, 250)",
                        paddingLeft: "0.5rem",
                        marginTop: "15px",
                        marginBottom: "10px",
                        height: "160px",
                      }}
                    >
                      <span
                        style={{
                          marginBottom: "0.5rem",
                          fontSize: "18px",
                          color: "#6A6A6A",
                          fontWeight: "700",
                        }}
                      >
                        Any Pet-Specific or Service Requirements We Should Know
                        About?
                      </span>
                      <input
                        name="specific_requirement"
                        style={{
                          marginBottom: "1rem",
                          width: "98%",
                          height: "4rem",
                        }}
                        value={input.specific_requirement}
                        disabled
                      />
                      <span
                        style={{
                          marginBottom: "0.5rem",
                          fontSize: "18px",
                          color: "#6A6A6A",
                          fontWeight: "700",
                        }}
                      >
                        Price
                      </span>
                      <input
                        name="price"
                        style={{
                          marginBottom: "1rem",
                          width: "15%",
                          height: "4rem",
                        }}
                        value={input.price}
                        disabled
                      />
                    </div>
                  ))}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <button
                      disabled
                      style={{
                        position: "relative",
                        padding: "0px",
                        backgroundColor: "transparent",
                        border: "none",
                      }}
                    >
                      <img
                        src={rectangle}
                        alt="Add"
                        style={{ width: "100%", height: "auto" }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                      >
                        <img
                          src={add}
                          alt="Overlay"
                          style={{ width: "80%", height: "auto" }}
                        />
                      </div>
                    </button>
                  </div>
                </div>

                <div>
                  <div className="row">
                    <div className="col-12">
                      <h3 style={{ fontSize: "20px", fontWeight: "600" }}>
                        Mandatory Requirements for{" "}
                        <span style={{ fontSize: "15px", color: "#5B489D" }}>
                          Cargo
                        </span>
                      </h3>
                    </div>
                    <hr
                      style={{
                        position: "relative",
                        width: "98%",
                        marginLeft: "14px",
                        marginTop: "-4px",
                        padding: "0px 23px 0px 15px",
                      }}
                    />
                  </div>
                  <div className="row">
                    <div className="col-4">
                      <table
                        style={{
                          background: "rgb(248, 249, 250)",
                          width: "100%",
                          borderRadius: "12px",
                          marginBottom: "12px",
                        }}
                      >
                        {/* Question Header */}
                        <tr style={{ display: "flex" }}>
                          <td
                            style={{
                              padding: "0.5rem",
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                              color: "#6A6A6A",
                              fontWeight: "600",
                            }}
                          >
                            <input
                              type="radio"
                              name="fit_to_fly_requirement"
                              value="false"
                              checked={
                                domesticSOW.fit_to_fly_requirement === false
                              }
                              disabled
                            />
                            <label>Export Noc</label>
                          </td>
                        </tr>
                        {/* Dropdown and Input Fields */}
                        <div style={{ padding: "0 11px 13px 30px" }}>
                          <span>
                            A Non-Objection Certificate is required from AQCS
                            before travel. Certificate is valid for 10 days.{" "}
                          </span>
                        </div>
                      </table>
                    </div>
                    <div className="col-4">
                      <table
                        style={{
                          background: "rgb(248, 249, 250)",
                          width: "100%",
                          borderRadius: "12px",
                          marginBottom: "12px",
                        }}
                      >
                        {/* Question Header */}
                        <tr style={{ display: "flex" }}>
                          <td
                            style={{
                              padding: "0.5rem",
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                              color: "#6A6A6A",
                              fontWeight: "600",
                            }}
                          >
                            <input
                              type="radio"
                              name="fit_to_fly_requirement"
                              value="false"
                              checked={
                                domesticSOW.fit_to_fly_requirement === false
                              }
                              disabled
                            />
                            <label>Air Freight</label>
                          </td>
                        </tr>
                        {/* Dropdown and Input Fields */}
                        <div style={{ padding: "0 11px 13px 30px" }}>
                          <span>
                            Additional charges for shipment traveling as air
                            freight. Applied on the basis of volumetric weight.{" "}
                          </span>
                        </div>
                      </table>
                    </div>
                    <div className="col-4">
                      <table
                        style={{
                          background: "rgb(248, 249, 250)",
                          width: "100%",
                          borderRadius: "12px",
                          marginBottom: "12px",
                        }}
                      >
                        {/* Question Header */}
                        <tr style={{ display: "flex" }}>
                          <td
                            style={{
                              padding: "0.5rem",
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                              color: "#6A6A6A",
                              fontWeight: "600",
                            }}
                          >
                            <input
                              type="radio"
                              name="fit_to_fly_requirement"
                              value="false"
                              checked={
                                domesticSOW.fit_to_fly_requirement === false
                              }
                              disabled
                            />
                            <label>Export Custom Clearance</label>
                          </td>
                        </tr>
                        {/* Dropdown and Input Fields */}
                        <div style={{ padding: "0 11px 13px 30px" }}>
                          <span>
                            Standard charges levied for transporting a live
                            animal and obtaining customs clearance for pet
                            travel at origin.{" "}
                          </span>
                        </div>
                      </table>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-4">
                      <table
                        style={{
                          background: "rgb(248, 249, 250)",
                          width: "100%",
                          borderRadius: "12px",
                          marginBottom: "12px",
                        }}
                      >
                        {/* Question Header */}
                        <tr style={{ display: "flex" }}>
                          <td
                            style={{
                              padding: "0.5rem",
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                              color: "#6A6A6A",
                              fontWeight: "600",
                            }}
                          >
                            <input
                              type="radio"
                              name="fit_to_fly_requirement"
                              value="false"
                              checked={
                                domesticSOW.fit_to_fly_requirement === false
                              }
                              disabled
                            />
                            <label>Terminal Charges</label>
                          </td>
                        </tr>
                        {/* Dropdown and Input Fields */}
                        <div style={{ padding: "0 11px 13px 30px" }}>
                          <span>
                            Standard charges levied for transporting a live
                            animal and obtaining terminal clearance at point of
                            origin.{" "}
                          </span>
                        </div>
                      </table>
                    </div>
                  </div>
                </div>

                <div style={{ paddingTop: "20px" }}>
                  <div className="row">
                    <div className="col-12">
                      <h3 style={{ fontSize: "20px", fontWeight: "600" }}>
                        Destination Based{" "}
                        <span style={{ fontSize: "15px", color: "#5B489D" }}>
                          Requirements
                        </span>
                      </h3>
                    </div>
                    <hr
                      style={{
                        position: "relative",
                        width: "98%",
                        marginLeft: "14px",
                        marginTop: "-4px",
                        padding: "0px 23px 0px 15px",
                      }}
                    />
                  </div>
                  <div className="row">
                    <div className="col-4">
                      <table
                        style={{
                          background: "rgb(248, 249, 250)",
                          width: "100%",
                          borderRadius: "12px",
                          marginBottom: "12px",
                        }}
                      >
                        {/* Question Header */}
                        <tr style={{ display: "flex" }}>
                          <td
                            style={{
                              padding: "0.5rem",
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                              color: "#6A6A6A",
                              fontWeight: "600",
                            }}
                          >
                            <input
                              type="radio"
                              name="fit_to_fly_requirement"
                              value="false"
                              checked={
                                domesticSOW.fit_to_fly_requirement === false
                              }
                              disabled
                            />
                            <label>Import Permit</label>
                          </td>
                        </tr>
                        {/* Dropdown and Input Fields */}
                        <div style={{ padding: "0 11px 13px 30px" }}>
                          <span>
                            An import permit is required before travel.{" "}
                          </span>
                        </div>
                      </table>
                    </div>
                    <div className="col-4">
                      <table
                        style={{
                          background: "rgb(248, 249, 250)",
                          width: "100%",
                          borderRadius: "12px",
                          marginBottom: "12px",
                        }}
                      >
                        {/* Question Header */}
                        <tr style={{ display: "flex" }}>
                          <td
                            style={{
                              padding: "0.5rem",
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                              color: "#6A6A6A",
                              fontWeight: "600",
                            }}
                          >
                            <input
                              type="radio"
                              name="fit_to_fly_requirement"
                              value="false"
                              checked={
                                domesticSOW.fit_to_fly_requirement === false
                              }
                              disabled
                            />
                            <label>Import Custom Clearance</label>
                          </td>
                        </tr>
                        {/* Dropdown and Input Fields */}
                        <div style={{ padding: "0 11px 13px 30px" }}>
                          <span>
                            Standard charges levied for transporting a live
                            animal and obtaining customs clearance for pet
                            travel at destination.{" "}
                          </span>
                        </div>
                      </table>
                    </div>
                    <div className="col-4">
                      <table
                        style={{
                          background: "rgb(248, 249, 250)",
                          width: "100%",
                          borderRadius: "12px",
                          marginBottom: "12px",
                        }}
                      >
                        {/* Question Header */}
                        <tr style={{ display: "flex" }}>
                          <td
                            style={{
                              padding: "0.5rem",
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                              color: "#6A6A6A",
                              fontWeight: "600",
                            }}
                          >
                            <input
                              type="radio"
                              name="fit_to_fly_requirement"
                              value="false"
                              checked={
                                domesticSOW.fit_to_fly_requirement === false
                              }
                              disabled
                            />
                            <label>Door-to-Door Delivery</label>
                          </td>
                        </tr>
                        {/* Dropdown and Input Fields */}
                        <div style={{ padding: "0 11px 13px 30px" }}>
                          <span>
                            We pick up, transport, and drop your pet from your
                            destination’s airport to your doorstep.{" "}
                          </span>
                        </div>
                      </table>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-4">
                      <table
                        style={{
                          background: "rgb(248, 249, 250)",
                          width: "100%",
                          borderRadius: "12px",
                          marginBottom: "12px",
                        }}
                      >
                        {/* Question Header */}
                        <tr style={{ display: "flex" }}>
                          <td
                            style={{
                              padding: "0.5rem",
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                              color: "#6A6A6A",
                              fontWeight: "600",
                            }}
                          >
                            <input
                              type="radio"
                              name="fit_to_fly_requirement"
                              value="false"
                              checked={
                                domesticSOW.fit_to_fly_requirement === false
                              }
                              disabled
                            />
                            <label>
                              CDC Dog Import Permit <span>only for us</span>
                            </label>
                          </td>
                        </tr>
                        {/* Dropdown and Input Fields */}
                        <div style={{ padding: "0 11px 13px 30px" }}>
                          <span>
                            A CDC import permit is required to enter the US with
                            your dog. Valid for 1 month from date of issue.
                          </span>
                        </div>
                      </table>
                    </div>
                  </div>
                </div>

                <table
                  style={{
                    background: "rgb(248, 249, 250)",
                    width: "100%",
                    borderRadius: "12px",
                    marginTop: "1rem",
                  }}
                >
                  <tr>
                    <th
                      style={{
                        fontSize: "18px",
                        color: "#6A6A6A",
                        paddingTop: "1rem",
                        paddingLeft: "0.5rem",
                        paddingBottom: "0.2rem",
                      }}
                    >
                      Any Pet-Specific or Service Requirements We Should Know About? 
                    </th>
                  </tr>
                  <tr>
                    <td className="internationtd_placeholder"
                      colSpan={3}
                      style={{ paddingBottom: "1rem" }}
                    >
                      <input
                        style={{
                          borderRadius: "1px solid #6A6A6A",
                          width: "100%",
                          height: '110px'
                          
                        }}
                        type="input"
                        name="remark"
                        value={domesticSOW.remark}
                        onChange={handleChange2}
                        placeholder= 'Enter'
                        disabled
                      />
                    </td>
                  </tr>
                </table>

                <div>
                  {inputs.map((input, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        background: "rgb(248, 249, 250)",
                        paddingLeft: "0.5rem",
                        marginTop: "15px",
                        marginBottom: "10px",
                        height: "160px",
                      }}
                    >
                      <span
                        style={{
                          marginBottom: "0.5rem",
                          fontSize: "18px",
                          color: "#6A6A6A",
                          fontWeight: "700",
                        }}
                      >
                        Any Pet-Specific or Service Requirements We Should Know
                        About?
                      </span>
                      <input
                        name="specific_requirement"
                        style={{
                          marginBottom: "1rem",
                          width: "98%",
                          height: "4rem",
                        }}
                        value={input.specific_requirement}
                        disabled
                      />
                      <span
                        style={{
                          marginBottom: "0.5rem",
                          fontSize: "18px",
                          color: "#6A6A6A",
                          fontWeight: "700",
                        }}
                      >
                        Price
                      </span>
                      <input
                        name="price"
                        style={{
                          marginBottom: "1rem",
                          width: "15%",
                          height: "4rem",
                        }}
                        value={input.price}
                        disabled
                      />
                    </div>
                  ))}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <button
                      disabled
                      style={{
                        position: "relative",
                        padding: "0px",
                        backgroundColor: "transparent",
                        border: "none",
                      }}
                    >
                      <img
                        src={rectangle}
                        alt="Add"
                        style={{ width: "100%", height: "auto" }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                      >
                        <img
                          src={add}
                          alt="Overlay"
                          style={{ width: "80%", height: "auto" }}
                        />
                      </div>
                    </button>
                  </div>
                </div>
              </>
            )}
          </Wrapper>

        
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-start",
            }}
          >
            <button
              onClick={handleSave}
              style={{
                alignSelf: "flex-start",
                marginRight: "2rem",
                padding: 0,
                border: "none",
                background: "none",
              }}
            >
              <img
                src={updatebutton}
                alt="update"
                style={{ width: "200px", height: "50px", marginTop: "1rem" }}
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InternationalRelocation;
